<div class="page-wrapper">
  <section>
    <div class="content-wrapper">
      <app-page-retrieval-error
        *ngIf="pageRetrievalError()"
      ></app-page-retrieval-error>

      <ng-container *ngIf="!pageRetrievalError() && partner() as partner">
        <div class="heading-container">
          <h1>{{ partner.banner_title }}</h1>
        </div>

        <div class="desktop-layout">
          <div class="body">
            <div class="body-header">
              <!-- Partner Title -->
              <div class="title">
                <h2>{{ partner.howden_title }}</h2>
              </div>
              <div class="seperator"></div>
              <!-- Partner logo -->
              <img
                class="partner-logo"
                [src]="partner.partner?.data?.attributes?.url"
              />
            </div>

            <!-- Heading Image -->
            <img
              class="heading-image mobile"
              [src]="partner.heading_image?.data?.attributes?.url"
            />

            <div
              class="partner-content"
              [style.--heading-color]="partner.content_subtitle_colour"
            >
              <app-render-markdown
                [content]="partner.partner_content"
              ></app-render-markdown>
            </div>
            <div class="bottom-section">
              <h2>{{ partner.app_section_heading }}</h2>
              <p>{{ partner.app_section_body }}</p>
              <div class="lozenges">
                <a
                  [href]="partner.ios_app_link"
                  *ngIf="partner.ios_lozenge?.data?.attributes?.url"
                  ><img
                    [src]="partner.ios_lozenge?.data?.attributes?.url"
                    alt="ios lozenge"
                /></a>
                <a
                  [href]="partner.android_app_link"
                  *ngIf="partner.android_lozenge?.data?.attributes?.url"
                  ><img
                    [src]="partner.android_lozenge?.data?.attributes?.url"
                    alt="android lozenge"
                /></a>
              </div>
            </div>
          </div>
          <!-- Heading Image -->
          <img
            class="heading-image desktop"
            [src]="partner.heading_image?.data?.attributes?.url"
          />
        </div>
      </ng-container>
    </div>
  </section>
</div>
